module.exports = __webpack_public_path__ + "img/scene14.df3b0a29.gif";